var map = {
	"./arrows-horizontal.svg": 215,
	"./font/iconfont.svg": 360,
	"./logo-fw-simple.svg": 361,
	"./logo-fw.png.svg": 362,
	"./logo-fw.svg": 363,
	"./logo-yimian.svg": 365,
	"./logo.svg": 366,
	"./logos/oneview.svg": 367,
	"./logos/wechat.svg": 216,
	"./logos/yidrone.svg": 368,
	"./logos/yimian.svg": 217,
	"./success.svg": 369,
	"./warning.svg": 370
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 404;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.svg$
// module id = 404
// module chunks = 1